import { render, staticRenderFns } from "./HeaderScrollLinks.vue?vue&type=template&id=5505aa97&scoped=true&lang=pug"
import script from "./HeaderScrollLinks.vue?vue&type=script&lang=js"
export * from "./HeaderScrollLinks.vue?vue&type=script&lang=js"
import style0 from "./HeaderScrollLinks.vue?vue&type=style&index=0&id=5505aa97&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5505aa97",
  null
  
)

export default component.exports